import type { WellInfo } from './procurementRequest';

/** Master well from GET /api/master/wells or the /api/wells register over master data. */
export interface WellMaster {
  id: string;
  wellKey: string;
  wellName: string;
  field: string;
  /** Region catalog field id when the well is tied to a defined field. */
  fieldId: string;
  fieldCounty: string;
  fieldState: string;
  /** Basin or aquifer; see WELL_REGION_OPTIONS. */
  region: string;
  state: string;
  country: string;
  depthFt?: number;
  reservoirType: string;
}

export function normalizeWellKey(key: string): string {
  return key.trim().toUpperCase();
}

export function mapApiWell(raw: Record<string, unknown>): WellMaster {
  return {
    id: String(raw.id ?? ''),
    wellKey: String(raw.wellKey ?? ''),
    wellName: String(raw.wellName ?? ''),
    field: String(raw.field ?? ''),
    fieldId: String(raw.fieldId ?? ''),
    fieldCounty: String(raw.fieldCounty ?? ''),
    fieldState: String(raw.fieldState ?? ''),
    region: String(raw.region ?? ''),
    state: String(raw.state ?? ''),
    country: String(raw.country ?? ''),
    depthFt: raw.depthFt === null || raw.depthFt === undefined ? undefined : Number(raw.depthFt),
    reservoirType: String(raw.reservoirType ?? '')
  };
}

export function mapMasterWellToPicker(raw: Record<string, unknown>): WellMaster {
  return {
    id: String(raw.id ?? ''),
    wellKey: String(raw.apiNumber ?? raw.wellKey ?? ''),
    wellName: String(raw.name ?? raw.wellName ?? ''),
    field: String(raw.field ?? ''),
    fieldId: String(raw.fieldId ?? ''),
    fieldCounty: String(raw.county ?? raw.fieldCounty ?? ''),
    fieldState: String(raw.state ?? raw.fieldState ?? ''),
    region: String(raw.operatingRegion ?? raw.region ?? ''),
    state: String(raw.state ?? ''),
    country: String(raw.country ?? ''),
    depthFt: raw.depthFt === null || raw.depthFt === undefined ? undefined : Number(raw.depthFt),
    reservoirType: String(raw.wellType ?? raw.reservoirType ?? '')
  };
}

export function wellMasterToFormWellInfo(w: WellMaster): WellInfo {
  return {
    wellId: w.id,
    apiNumber: w.wellKey,
    wellName: w.wellName,
    field: w.field,
    region: w.region,
    location: { state: w.state, country: w.country },
    depthFt: w.depthFt,
    reservoirType: w.reservoirType
  };
}

/** GET /api/wells/{id}/po-spend — camelCase JSON. */
export type WellPoSpendGranularity = 'yearly' | 'monthly' | 'quarterly';

export interface WellPoSpendPoint {
  label: string;
  periodKey: string;
  totalAmount: number;
  purchaseOrderCount: number;
}

export interface WellPoSpendSeries {
  granularity: string;
  calendarYear: number | null;
  points: WellPoSpendPoint[];
}
